import { ConfigResponse } from '../../types/configResponse';
import { ConfigTypes } from './types';

export const SetConfigData = (data: ConfigResponse) => ({
 type: ConfigTypes.SET_CONFIG,
 data
});
